var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.2001,
    cy: 25.3251,
    r: 25.1337,
    fill: "#003A9B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6467 24.459L28.2677 16.2687C28.8161 15.7475 29.7053 15.7475 30.2534 16.2687C30.8016 16.7896 30.8016 17.6343 30.2534 18.155L22.6251 25.4022L30.2532 32.6491C30.8014 33.1701 30.8014 34.0147 30.2532 34.5355C29.705 35.0565 28.8159 35.0565 28.2675 34.5355L19.6464 26.3451C19.3724 26.0846 19.2355 25.7435 19.2355 25.4022C19.2355 25.0608 19.3726 24.7194 19.6467 24.459Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.53ff9d00e6edf5a313372a2dd03daa52.svg";
export { ForwardRef as ReactComponent };